module.exports = __webpack_public_path__ + "static/img/wangxingxing.cfee1b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/touxiang/wangxingxing.png
// module id = fTjU
// module chunks = 0